module.exports = __webpack_public_path__ + "bradavice_2_after.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/llc/surgery/procedures/dermatologie/bradavice_2_after.jpg
// module id = 931
// module chunks = 0